module.exports = __webpack_public_path__ + "static/media/file-spreadsheet.bf2d0cef.svg";